export const makeBidDocumentFileMethods = {
  isImageFile(fileName) {
    const ext = (fileName || '').split('.').pop().toLowerCase()
    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)
  },

  getFileIcon(fileName) {
    const ext = (fileName || '').split('.').pop().toLowerCase()
    const iconMap = {
      pdf: 'el-icon-document',
      doc: 'el-icon-document-copy',
      docx: 'el-icon-document-copy',
      xls: 'el-icon-s-data',
      xlsx: 'el-icon-s-data',
      jpg: 'el-icon-picture-outline',
      jpeg: 'el-icon-picture-outline',
      png: 'el-icon-picture-outline',
      gif: 'el-icon-picture-outline'
    }
    return iconMap[ext] || 'el-icon-document'
  },

  previewPendingFile(file) {
    if (!file || !file.raw) {
      this.$message.warning('文件不存在')
      return
    }
    const url = URL.createObjectURL(file.raw)
    this.previewUrl = url
    this.previewTitle = file.name
    this.previewVisible = true
  },

  closePreview() {
    this.previewVisible = false
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl)
      this.previewUrl = ''
    }
  },

  handleAttFileChange(file, fileList) {
    // 浅拷贝一份新数组，防止 el-upload 销毁时清空内部 uploadFiles 数组导致 pendingAttFiles 也被清空
    this.pendingAttFiles = fileList.map(f => ({ ...f, raw: f.raw }))
    // 将 raw File 对象缓存到非响应式 Map，避免 el-upload 响应式循环或 sessionStorage 序列化导致 raw 丢失
    if (!this._attRawFileCache) this._attRawFileCache = {}
    fileList.forEach(f => {
      if (f.raw instanceof Blob && f.uid) {
        this._attRawFileCache[f.uid] = f.raw
      }
    })
    this.$message.success(`已选择 ${fileList.length} 个附件文件，点击保存后上传`)
  },

  removePendingAtt(index) {
    const removed = this.pendingAttFiles[index]
    if (removed && removed.uid && this._attRawFileCache) {
      delete this._attRawFileCache[removed.uid]
    }
    this.pendingAttFiles.splice(index, 1)
    if (this.$refs.attUploader) {
      this.$refs.attUploader.uploadFiles.splice(index, 1)
    }
  },

  handleSignFileChange(file, fileList) {
    this.pendingSignFiles = fileList
    this.$message.success(`已选择 ${fileList.length} 个签章文件，点击保存后上传`)
  },

  removePendingSign(index) {
    this.pendingSignFiles.splice(index, 1)
    if (this.$refs.signUploader) {
      this.$refs.signUploader.uploadFiles.splice(index, 1)
    }
  },

  handleMainFileChange(file, fileList) {
    this.currentMainState.pendingMainFile = fileList[0] || null
    if (this.currentMainState.pendingMainFile) {
      if (this.currentMainState.previewMainUrl) {
        URL.revokeObjectURL(this.currentMainState.previewMainUrl)
      }
      this.currentMainState.previewMainUrl = URL.createObjectURL(this.currentMainState.pendingMainFile.raw)
      this.currentMainState.mainEncryptResult = ''
      this.currentMainState.mainEncryptSuccess = false
      this.$message.success(`已选择${this.currentMainLabel}文件，点击保存后上传`)
    }
  },

  handleMainReupload(file, fileList) {
    if (this.currentMainState.previewMainUrl) {
      URL.revokeObjectURL(this.currentMainState.previewMainUrl)
      this.currentMainState.previewMainUrl = ''
    }
    // 始终使用最新一次选择的 file，避免 fileList[0] 拿到旧文件
    this.currentMainState.pendingMainFile = file || null
    if (this.currentMainState.pendingMainFile) {
      this.currentMainState.previewMainUrl = URL.createObjectURL(this.currentMainState.pendingMainFile.raw)
      this.currentMainState.mainEncryptResult = ''
      this.currentMainState.mainEncryptSuccess = false
      this.$message.success(`已选择新的${this.currentMainLabel}文件，将覆盖之前的文件`)
    }
    // 同步 el-upload 内部 uploadFiles，防止多次重新上传后累积导致后续 limit/状态异常
    this.$nextTick(() => {
      if (this.$refs.mainUploader && Array.isArray(this.$refs.mainUploader.uploadFiles)) {
        this.$refs.mainUploader.uploadFiles = file ? [file] : []
      }
    })
  },

  removePendingMain() {
    this.currentMainState.pendingMainFile = null
    if (this.currentMainState.previewMainUrl) {
      URL.revokeObjectURL(this.currentMainState.previewMainUrl)
      this.currentMainState.previewMainUrl = ''
    }
    if (this.$refs.mainUploader) {
      this.$refs.mainUploader.uploadFiles = []
    }
  },

  handleMainFileRemove() {
    this.currentMainState.pendingMainFile = null
    if (this.currentMainState.previewMainUrl) {
      URL.revokeObjectURL(this.currentMainState.previewMainUrl)
      this.currentMainState.previewMainUrl = ''
    }
  },

  async handleGoSign() {
    this.$router.push({
      path: '/sign/pdf',
      query: { sectionCode: this.projectInfo.sectionCode }
    })
  },

  savePageStateBeforeSign() {
    return false
  },

  checkSignedPdf() {
    return false
  }
}
